import React from 'react'
import { Route, Switch, withRouter, Redirect } from 'react-router-dom'
import classnames from 'classnames'

// styles
import useStyles from './styles'

// components
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import ChassisDocumentImportDialogWrapper from '../components/Chassis/components/ChassisDocumentImportDialogWrapper'

// pages
import Dashboard from '../pages/dashboard'
import Error from '../pages/error'

// context
import { useLayoutState } from '../context/LayoutContext'
import { useUserState, defaultRoute } from '../context/user/UserContext'
import VehicleTypesList from '../pages/vehicle-types-list'
import ChassisList from '../pages/chassis-list'
import MarketTracking from '../pages/market-tracking'
import QuickFilterAutoApplyGuard from '../components/QuickFilters/QuickFilterAutoApplyGuard'
import ChassisDetail from '../pages/chassis-detail'
import ControlsList from '../pages/controls-list'
import ControlsDetailList from '../pages/controls-detail-list'
import UsersList from '../pages/users-list'
import ControlsDetail from '../pages/controls-detail'
import ConstructorsList from '../pages/constructor-list'
import ConstructorControlsList from '../pages/constructor-controls-list'
import ConstructorControlsDetail from '../pages/constructor-controls-detail'
import OperatorsList from '../pages/operators-list'
import ContractorsList from '../pages/contractor-list'
import MembersList from '../pages/members-list'
import MemberControlsList from '../pages/member-controls-list'
import MemberControlsDetail from '../pages/member-controls-detail'
import Permissions from '../pages/permissions'
import VehicleTypeDetail from '../pages/vehicle-type-detail'
import DepotsList from '../pages/depots-list'
import EmailListsList from '../pages/email-lists-list'
import Statistics from '../pages/statistics'
import PVAdmissionManagement from '../pages/pv-admission-management'
import ControlLocationsList from '../pages/control-locations'
import SubscriptionsList from '../pages/subscriptions'

function Layout({ history }) {
  const classes = useStyles()
  const { user } = useUserState()

  // global
  const layoutState = useLayoutState()

  return (
    <div className={classes.root}>
      <>
        <Header history={history} />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <Switch>
            <Route
              exact
              path="/"
              render={() => <Redirect to={defaultRoute(user)} />}
            />
            <Route path="/dashboard" component={Dashboard} exact />
            <Route path="/dashboard/statistics" component={Statistics} />
            <Route
              path="/vehicle-types/list"
              component={VehicleTypesList}
              exact
            />
            <Route
              path="/vehicle-types/detail/:id"
              component={VehicleTypeDetail}
            />
            <Route
              path="/controls/list"
              exact
              render={(props) => (
                <QuickFilterAutoApplyGuard pageType="controls">
                  <ControlsList {...props} />
                </QuickFilterAutoApplyGuard>
              )}
            />
            <Route
              path="/controls/detail-list"
              render={(props) => (
                <QuickFilterAutoApplyGuard pageType="controls-detail">
                  <ControlsDetailList {...props} />
                </QuickFilterAutoApplyGuard>
              )}
            />
            <Route path="/controls/detail/:id" component={ControlsDetail} />
            <Route
              path="/controls/control-locations"
              component={ControlLocationsList}
            />
            <Route
              path="/chassis/list"
              render={(props) => (
                <QuickFilterAutoApplyGuard pageType="chassis">
                  <ChassisList {...props} />
                </QuickFilterAutoApplyGuard>
              )}
            />
            <Route
              path="/chassis/pv-admission-management"
              component={PVAdmissionManagement}
            />
            <Route path="/chassis/market-tracking" component={MarketTracking} />
            <Route path="/chassis/detail/:id" component={ChassisDetail} />
            <Route path="/users/list" component={UsersList} exact />
            <Route path="/users/permissions" component={Permissions} />
            <Route path="/users/subscriptions" component={SubscriptionsList} />
            <Route path="/constructors/list" component={ConstructorsList} />
            <Route
              path="/constructors/controls"
              component={ConstructorControlsList}
              exact
            />
            <Route
              path="/constructor-controls/detail/:id"
              component={ConstructorControlsDetail}
            />
            <Route path="/operators/list" component={OperatorsList} />
            <Route path="/contractors/list" component={ContractorsList} />
            <Route path="/members/list" component={MembersList} />
            <Route
              path="/members/controls"
              component={MemberControlsList}
              exact
            />
            <Route
              path="/member-controls/detail/:id"
              component={MemberControlsDetail}
            />
            <Route path="/depots/list" component={DepotsList} />
            <Route path="/email-lists/list" component={EmailListsList} />
            <Route component={Error} />
          </Switch>
        </div>
        {/* Global dialog for document import - can be opened from any page via notifications */}
        <ChassisDocumentImportDialogWrapper
          open={false}
          onClose={() => {}}
          onComplete={() => {}}
        />
      </>
    </div>
  )
}

export default withRouter(Layout)
